import './button';
import './enfatize';
import './image';
import './imageSelector';
import './input';
import './inputCheck';
import './inputDate';
import './inputImage';
import './inputSelect';
import './inputSuggest';
import './inputSwitch';
import './layout';
import './loading';
import './modal';
import './radioOption';
import './selectItem';
import './slider';
import './text';
import './textCurrency';
import './textField';
import './view';

const index = {};

export default index;
